import { render, staticRenderFns } from "./CreditNote.vue?vue&type=template&id=4a72f16d&scoped=true"
import script from "./CreditNote.vue?vue&type=script&lang=js"
export * from "./CreditNote.vue?vue&type=script&lang=js"
import style0 from "./CreditNote.vue?vue&type=style&index=0&id=4a72f16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72f16d",
  null
  
)

export default component.exports